<template lang="html">
  <div class="btn-icon">
    <span v-if="nameIcon === 'download'" class="icon">
      <svg
        width="21"
        height="24"
        viewBox="0 0 21 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.2931 21.4737H19.3966C19.7395 21.4737 20.0684 21.6068 20.3109 21.8437C20.5534 22.0805 20.6897 22.4018 20.6897 22.7368C20.6897 23.0719 20.5534 23.3931 20.3109 23.63C20.0684 23.8669 19.7395 24 19.3966 24H1.2931C0.950151 24 0.621245 23.8669 0.378741 23.63C0.136238 23.3931 0 23.0719 0 22.7368C0 22.4018 0.136238 22.0805 0.378741 21.8437C0.621245 21.6068 0.950151 21.4737 1.2931 21.4737ZM11.6379 14.1158L15.8315 10.0206L17.6599 11.8067L10.3448 18.9524L3.02974 11.8067L4.85819 10.0206L9.05172 14.1158V0H11.6379V14.1158Z"
          fill="url(#paint0_radial_173_971)"
          fill-opacity="0.97"
        />
        <defs>
          <radialGradient
            id="paint0_radial_173_971"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(10.3448 7.44) rotate(90) scale(16.56 14.2759)"
          >
            <stop stop-color="#33647E" />
            <stop offset="1" stop-color="#013652" />
          </radialGradient>
        </defs>
      </svg>
    </span>
    <span v-else-if="nameIcon === 'print'" class="icon">
      <svg
        width="24"
        height="23"
        viewBox="0 0 24 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.3069 5.11477H19.6187V0.725637C19.6187 0.324795 19.2938 0 18.8931 0H5.10703C4.70629 0 4.38139 0.324795 4.38139 0.725637V5.11477H1.69315C0.759596 5.11477 0 5.87427 0 6.80792V16.1178C0 17.0514 0.759596 17.811 1.69315 17.811H4.38139V21.4104C4.38139 21.8113 4.70629 22.1361 5.10703 22.1361H18.893C19.2937 22.1361 19.6186 21.8113 19.6186 21.4104V17.811H22.3068C23.2404 17.811 24 17.0514 24 16.1178V6.80792C24.0001 5.87437 23.2405 5.11477 22.3069 5.11477ZM5.83267 1.45127H18.1673V5.11477H5.83267V1.45127ZM18.1673 20.6848H5.83267V13.4861H18.1673V20.6848ZM22.5488 16.1178C22.5488 16.2489 22.438 16.3597 22.3069 16.3597H19.6187V12.7605C19.6187 12.3596 19.2938 12.0348 18.8931 12.0348H5.10703C4.70629 12.0348 4.38139 12.3596 4.38139 12.7605V16.3597H1.69315C1.56205 16.3597 1.45127 16.2489 1.45127 16.1178V6.80792C1.45127 6.67673 1.56205 6.56604 1.69315 6.56604H5.10703H18.893H22.3068C22.4379 6.56604 22.5487 6.67673 22.5487 6.80792L22.5488 16.1178Z"
          fill="url(#paint0_radial_164_937)"
          fill-opacity="0.97"
        />
        <path
          d="M18.8925 10.3326C19.4625 10.3326 19.9246 9.87049 19.9246 9.30046C19.9246 8.73042 19.4625 8.26831 18.8925 8.26831C18.3225 8.26831 17.8604 8.73042 17.8604 9.30046C17.8604 9.87049 18.3225 10.3326 18.8925 10.3326Z"
          fill="url(#paint1_radial_164_937)"
          fill-opacity="0.97"
        />
        <path
          d="M15.301 14.918H8.69829C8.29755 14.918 7.97266 15.2428 7.97266 15.6436C7.97266 16.0445 8.29755 16.3693 8.69829 16.3693H15.301C15.7018 16.3693 16.0266 16.0445 16.0266 15.6436C16.0266 15.2429 15.7018 14.918 15.301 14.918Z"
          fill="url(#paint2_radial_164_937)"
          fill-opacity="0.97"
        />
        <path
          d="M15.301 17.8014H8.69829C8.29755 17.8014 7.97266 18.1262 7.97266 18.527C7.97266 18.9279 8.29755 19.2527 8.69829 19.2527H15.301C15.7018 19.2527 16.0266 18.9279 16.0266 18.527C16.0266 18.1262 15.7018 17.8014 15.301 17.8014Z"
          fill="url(#paint3_radial_164_937)"
          fill-opacity="0.97"
        />
        <defs>
          <radialGradient
            id="paint0_radial_164_937"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(12 6.86218) rotate(90) scale(15.2739 16.56)"
          >
            <stop stop-color="#33647E" />
            <stop offset="1" stop-color="#013652" />
          </radialGradient>
          <radialGradient
            id="paint1_radial_164_937"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(18.8925 8.90824) rotate(90) scale(1.42436)"
          >
            <stop stop-color="#33647E" />
            <stop offset="1" stop-color="#013652" />
          </radialGradient>
          <radialGradient
            id="paint2_radial_164_937"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(11.9997 15.3679) rotate(90) scale(1.00138 5.55725)"
          >
            <stop stop-color="#33647E" />
            <stop offset="1" stop-color="#013652" />
          </radialGradient>
          <radialGradient
            id="paint3_radial_164_937"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(11.9997 18.2513) rotate(90) scale(1.00138 5.55725)"
          >
            <stop stop-color="#33647E" />
            <stop offset="1" stop-color="#013652" />
          </radialGradient>
        </defs>
      </svg>
    </span>
    <span v-else-if="nameIcon === 'facebook'" class="icon stroke">
      <svg
        width="16"
        height="26"
        viewBox="0 0 16 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.2 1H10.6C9.0087 1 7.48258 1.63214 6.35736 2.75736C5.23214 3.88258 4.6 5.4087 4.6 7V10.6H1V15.4H4.6V25H9.4V15.4H13L14.2 10.6H9.4V7C9.4 6.68174 9.52643 6.37652 9.75147 6.15147C9.97652 5.92643 10.2817 5.8 10.6 5.8H14.2V1Z"
          stroke="url(#paint0_radial_164_946)"
          stroke-opacity="0.97"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <defs>
          <radialGradient
            id="paint0_radial_164_946"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(7.6 8.44) rotate(90) scale(16.56 9.108)"
          >
            <stop stop-color="#33647E" />
            <stop offset="1" stop-color="#013652" />
          </radialGradient>
        </defs>
      </svg>
    </span>
    <span v-else-if="nameIcon === 'linkedin'" class="icon stroke">
      <svg
        width="26"
        height="25"
        viewBox="0 0 26 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.7996 8.20001C19.7092 8.20001 21.5405 8.95858 22.8908 10.3088C24.241 11.6591 24.9996 13.4905 24.9996 15.4V23.8H20.1996V15.4C20.1996 14.7635 19.9468 14.153 19.4967 13.703C19.0466 13.2529 18.4361 13 17.7996 13C17.1631 13 16.5526 13.2529 16.1026 13.703C15.6525 14.153 15.3996 14.7635 15.3996 15.4V23.8H10.5996V15.4C10.5996 13.4905 11.3582 11.6591 12.7084 10.3088C14.0587 8.95858 15.8901 8.20001 17.7996 8.20001V8.20001Z"
          stroke="url(#paint0_radial_164_949)"
          stroke-opacity="0.97"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1 9.39996H5.8V23.8H1V9.39996Z"
          stroke="url(#paint1_radial_164_949)"
          stroke-opacity="0.97"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.4 5.8C4.72548 5.8 5.8 4.72548 5.8 3.4C5.8 2.07452 4.72548 1 3.4 1C2.07452 1 1 2.07452 1 3.4C1 4.72548 2.07452 5.8 3.4 5.8Z"
          stroke="url(#paint2_radial_164_949)"
          stroke-opacity="0.97"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <defs>
          <radialGradient
            id="paint0_radial_164_949"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(17.7996 13.036) rotate(90) scale(10.764 9.936)"
          >
            <stop stop-color="#33647E" />
            <stop offset="1" stop-color="#013652" />
          </radialGradient>
          <radialGradient
            id="paint1_radial_164_949"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(3.4 13.864) rotate(90) scale(9.936 3.312)"
          >
            <stop stop-color="#33647E" />
            <stop offset="1" stop-color="#013652" />
          </radialGradient>
          <radialGradient
            id="paint2_radial_164_949"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(3.4 2.488) rotate(90) scale(3.312)"
          >
            <stop stop-color="#33647E" />
            <stop offset="1" stop-color="#013652" />
          </radialGradient>
        </defs>
      </svg>
    </span>
    <span v-else-if="nameIcon === 'twitter'" class="icon stroke">
      <svg
        width="26"
        height="22"
        viewBox="0 0 26 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25 1.01097C23.9553 1.74785 22.7987 2.31145 21.5745 2.68006C20.9175 1.92462 20.0444 1.38918 19.0731 1.14616C18.1019 0.903145 17.0795 0.964274 16.1441 1.32128C15.2087 1.67829 14.4056 2.31395 13.8433 3.1423C13.2809 3.97064 12.9866 4.9517 13 5.95279V7.0437C11.0829 7.09341 9.18321 6.66822 7.47019 5.806C5.75717 4.94378 4.28398 3.6713 3.18182 2.10188C3.18182 2.10188 -1.18182 11.9201 8.63636 16.2837C6.38967 17.8087 3.71326 18.5734 1 18.4655C10.8182 23.9201 22.8182 18.4655 22.8182 5.92006C22.8172 5.61619 22.788 5.31307 22.7309 5.01461C23.8443 3.9166 24.63 2.53029 25 1.01097V1.01097Z"
          stroke="url(#paint0_radial_164_954)"
          stroke-opacity="0.97"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <defs>
          <radialGradient
            id="paint0_radial_164_954"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(13 7.06823) rotate(90) scale(13.5067 16.56)"
          >
            <stop stop-color="#33647E" />
            <stop offset="1" stop-color="#013652" />
          </radialGradient>
        </defs>
      </svg>
    </span>
    <span v-else class="icon">
      <svg
        width="21"
        height="24"
        viewBox="0 0 21 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.2931 21.4737H19.3966C19.7395 21.4737 20.0684 21.6068 20.3109 21.8437C20.5534 22.0805 20.6897 22.4018 20.6897 22.7368C20.6897 23.0719 20.5534 23.3931 20.3109 23.63C20.0684 23.8669 19.7395 24 19.3966 24H1.2931C0.950151 24 0.621245 23.8669 0.378741 23.63C0.136238 23.3931 0 23.0719 0 22.7368C0 22.4018 0.136238 22.0805 0.378741 21.8437C0.621245 21.6068 0.950151 21.4737 1.2931 21.4737ZM11.6379 14.1158L15.8315 10.0206L17.6599 11.8067L10.3448 18.9524L3.02974 11.8067L4.85819 10.0206L9.05172 14.1158V0H11.6379V14.1158Z"
          fill="url(#paint0_radial_173_971)"
          fill-opacity="0.97"
        />
        <defs>
          <radialGradient
            id="paint0_radial_173_971"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(10.3448 7.44) rotate(90) scale(16.56 14.2759)"
          >
            <stop stop-color="#33647E" />
            <stop offset="1" stop-color="#013652" />
          </radialGradient>
        </defs>
      </svg>
    </span>
  </div>
</template>
<script>
export default {
  props: {
    nameIcon: String,
  },
};
</script>
<style lang="css" scoped>
.btn-icon {
  min-width: 40px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  cursor: pointer;
  background: radial-gradient(to right, #33647e00, #01365200);
  transition: background 0.2s ease-in, transform 0.1s ease-in;
}
.btn-icon:active {
  transform: scale(0.8);
}
.btn-icon:hover {
  background: radial-gradient(69% 69% at 50% 31%, #33647e 0%, #013652 100%);
}
.btn-icon:hover .icon svg path {
  fill: #ffffff;
}
.btn-icon:hover .icon.stroke svg path {
  fill: none;
  stroke: #ffffff;
  stroke-opacity: 0.9;
}
</style>
